/**
 * One sidebar row: a 16px icon, then its label, in a 32px row. Spec beside
 * it in sidebar-row.md.
 *
 * @module components/ui/sidebar-row
 */
import { mergeProps } from "@base-ui/react/merge-props";
import { useRender } from "@base-ui/react/use-render";

import { cn } from "~/lib/utils";

export const SIDEBAR_ROW_CLASS = cn(
  "flex h-8 w-full cursor-pointer items-center gap-2 overflow-hidden rounded-md px-2.5 text-left text-[13px] font-normal text-sidebar-foreground/66 outline-hidden ring-ring transition-[background-color,color] duration-120 ease-out",
  "hover:bg-sidebar-row-hover hover:text-sidebar-foreground focus-visible:text-sidebar-foreground focus-visible:ring-2 active:bg-sidebar-row-active active:text-sidebar-foreground",
  "data-[active=true]:bg-sidebar-row-selected data-[active=true]:text-sidebar-foreground aria-selected:text-sidebar-foreground",
  "disabled:pointer-events-none disabled:opacity-50 aria-disabled:pointer-events-none aria-disabled:opacity-50",
  "[&>svg]:size-4 [&>svg]:shrink-0 [&>svg]:stroke-[1.75]",
);

export function SidebarRow({
  isActive = false,
  className,
  render,
  ...props
}: useRender.ComponentProps<"button"> & { readonly isActive?: boolean }) {
  const defaultProps = {
    className: cn(SIDEBAR_ROW_CLASS, className),
    "data-active": isActive,
    "data-slot": "sidebar-row",
  };
  return useRender({ defaultTagName: "button", props: mergeProps<"button">(defaultProps, props), render });
}
